import { Box, EmptyStates, Flex } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

import { fullPageHeight } from '../../../utils/size';

export const NoteDetailEmptyStates = () => {
  const { t } = useTranslation();

  return (
    <Box css={fullPageHeight}>
      <Flex h="100%" mih="inherit" align="center" justify="center">
        <EmptyStates image="ERROR" title={t('공개되지 않은 강의 노트입니다.')} />
      </Flex>
    </Box>
  );
};
